import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgInformationFill = (props) => /* @__PURE__ */ _jsx("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 24 24",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2ZM11.99 10H11C10.4477 10 10 10.4477 10 11C10 11.5128 10.386 11.9355 10.8834 11.9933L11 12V16.99C11 17.5106 11.3938 17.9392 11.8999 17.9941L12.01 18H12.5C13.0523 18 13.5 17.5523 13.5 17C13.5 16.671 13.3411 16.3791 13.0959 16.1969L13 16.1338V11.01C13 10.4894 12.6061 10.0608 12.1 10.0059L11.99 10ZM12 7C11.4477 7 11 7.44772 11 8C11 8.55228 11.4477 9 12 9C12.5523 9 13 8.55228 13 8C13 7.44772 12.5523 7 12 7Z" })
});
export default SvgInformationFill;
